import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const { completeLogin } = useAuth()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const error = params.get('error')

    // Clean the URL immediately regardless of outcome — no token to strip
    // anymore (the API set it as an httpOnly cookie before redirecting
    // here), but the ?error= param shouldn't linger in history either.
    window.history.replaceState({}, '', '/auth/callback')

    if (error) {
      navigate('/login?error=auth_failed', { replace: true })
      return
    }

    // completeLogin asks the API to confirm the session (the httpOnly
    // cookie the callback just set) and loads the profile.
    completeLogin()
      .then(() => {
        navigate('/locker-room', { replace: true })
      })
      .catch(() => {
        navigate('/login?error=auth_failed', { replace: true })
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-muted-foreground text-sm">Signing you in…</p>
    </div>
  )
}
